import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd6f8cee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "value", "checked"]
const _hoisted_2 = ["for", "title"]

import { FacetOptions } from '@/types/productServerApi';
import { computed } from 'vue';
import { isReadable } from '@ctrl/tinycolor';
import useMaterialAndColor from '@/shared/product/customizer/ui/overlays/material-and-color/useMaterialAndColor';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFacetColorSwatch',
  props: {
    option: null
  },
  setup(__props: any) {

const props = __props as {
    option: FacetOptions,
}

_useCssVars(_ctx => ({
  "4d94a25f": (_unref(background)),
  "1352559c": (_unref(outlineColor)),
  "891ffd82": (_unref(checkmarkColor))
}))




const { getIsSelectedColor, toggleSearchFacetColorsFilter } = useMaterialAndColor();

const fieldId = computed(() => {
    return props.option?.value ?? '' + Math.random();
});

const background = computed(() => props.option?.hexColor ?? 'transparent');
const shouldShowOutline = computed<boolean>(() => background.value === '#ffffff' || background.value === 'transparent');
const outlineColor = computed(() => shouldShowOutline.value ? '#000' : 'transparent');

const checkmarkIsReadable = computed<boolean>(() => {
    return isReadable('#000000', background.value);
});

const checkmarkColor = computed(() => checkmarkIsReadable.value ? '#000' : '#fff');


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      id: _unref(fieldId),
      type: "checkbox",
      name: "searchFacetColor",
      value: __props.option.value,
      checked: _unref(getIsSelectedColor)(__props.option.value),
      class: "sr-only",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleSearchFacetColorsFilter)(__props.option.value)))
    }, null, 40, _hoisted_1),
    _createElementVNode("label", {
      for: _unref(fieldId),
      class: "label",
      title: __props.option.title
    }, [
      _createTextVNode(_toDisplayString(__props.option.title) + " ", 1),
      _createVNode(_component_c_icon, {
        name: "icon-checkmark-medium",
        class: "icon"
      })
    ], 8, _hoisted_2)
  ], 64))
}
}

})